import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import format from 'date-fns/format'
import { Fragment } from 'react'

import { useBookingContext } from '@providers/booking'
import { TGroomArrivalTime } from '@providers/booking/types'
import { i18WithParams as t } from '@shared/locale'
import { Spacer } from 'components-ui/src/spacer/spacer'
import { Types } from 'service-api'
import { TPetOffers } from '../types'
import { getAvailableGroomers, getProviderSlots } from './helper'

interface IShowAnyGroomer {
  groomOffer: TPetOffers
  dateSelected: Date
  onSelect: (provider: Types.ProviderAdminDto, slot: TGroomArrivalTime) => void
}

export const ShowAnyGroomer = ({ groomOffer, dateSelected, onSelect }: IShowAnyGroomer) => {
  const bookingCtx = useBookingContext()
  const groomers = getAvailableGroomers(bookingCtx.state, groomOffer)
  if (!groomers) {
    return null
  }

  return (
    <Stack direction="column" alignItems="left" gap={1} flexWrap="wrap">
      {groomers.map((groomer) => {
        const slots = getProviderSlots(bookingCtx.state, groomOffer, groomer)
        if (!slots || slots.length === 0) {
          return null
        }
        return (
          <Fragment key={groomer.id}>
            <Typography variant="body1">
              {t('groomingWizard.anyGroomer.title', {
                groomer: groomer.displayName || '',
                date: format(dateSelected, 'MMM dd'),
              })}
            </Typography>
            <Divider />
            <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap">
              {slots?.map((slot) => {
                const selected =
                  groomOffer.resource?.id === groomer.id &&
                  groomOffer.requestDates[0]?.arrivalTime?.slotStartTime === slot.slotStartTime
                return (
                  <Button
                    key={slot.startTime}
                    variant={selected ? 'contained' : 'outlined'}
                    sx={{ borderRadius: '20px' }}
                    onClick={() => onSelect(groomer, slot)}
                  >
                    {slot.startTime}
                  </Button>
                )
              })}
            </Stack>
            <Spacer height={1} />
          </Fragment>
        )
      })}
    </Stack>
  )
}
